import { DefaultService } from '@/services/DefaultService';
export default class TransportadoraService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

  findAllOld(page = 0, limit = 50, ...params) {
    return this._http.get(encodeURI(`${this._env}/shippingcompany/order/all.json?page=${page}&limit=${limit}&param=${params}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
  }

	updateSituacao(transportadora) {
    return this._http.post(`${this._env}/vendas/transportadora/updatesituacao`, transportadora, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/transportadora.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/getcombo/transportadora.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

	find(id) {
		return this._http.get(`${this._env}/vendas/transportadora/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

	save(form) {
		return this._http.post(`${this._env}/vendas/transportadora`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  getInfoByCNPJ(uf, cnpj) {
    return this._http.get(`${this._env}/general/cnpj.json?uf=${uf}&cnpj=${cnpj}`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }
}